import React, { Component } from 'react';
import { shape, string, objectOf, object, number, func, bool } from 'prop-types';
import { get, orderBy } from 'lodash';
import BaseDataTable from '../../../BaseDataTable';
import WebTableRow from './WebTableRow';
import WebTableHeader from './WebTableHeader';
import WebTableSummary from './WebTableSummary';
import ModuleExport from '../../../ModuleExport';
import {
  MIN_LENGTH_WEB_ANALYTICS_DATA,
  MIN_LENGTH_CUSTOM_WEB_ANALYTICS_TABLE_ROWS,
  MAX_NUMBER_TABLE_ROWS_TO_TRUNCATE,
  GA_CHART_ID,
  partiableWebTableHeaders,
  newAdUsersKey,
} from '../../../../helpers/constant';

import styles from './styles.scss';
import { calculateTableRows } from '../../Report/helper';

export default class WebTable extends Component {
  static propTypes = {
    valueForTimeSelect: objectOf(shape({
      label: string,
      tableTitle: string,
      timeRange: string,
      icon: object
    })),
    timeRange: string,
    dataWebAnalytics: objectOf(shape({
      user: {},
      adUser: {},
      visit: {},
      adVisit: {},
      newAdUsers: {},
    })),
    range: string,
    campaignAvgAdCost: number,
    initialSortStatus: shape({
      sortKey: string,
      sortType: string
    }),
    fileName: string,
    onCellClick: func,
    inpdf: bool,
    page: number,
    isChartVisible: bool,
    rowsPerPage: number,
    isGrandTotalDisplay: bool,
    isCustomReport: bool,
    isWebChartVisible: bool,
    tableIndex: number,
    valueForTypeSelect: string,
    rowsFirstPage: number
  };

  static defaultProps = {
    valueForTimeSelect: { label: 'By Hour', timeRange: 'hourly', icon: {} },
    timeRange: 'hourly',
    dataWebAnalytics: {
      user: { daily: [{}], hourly: [{}], monthly: [{}], weekly: [{}] },
      adUser: { daily: [{}], hourly: [{}], monthly: [{}], weekly: [{}] },
      visit: { daily: [{}], hourly: [{}], monthly: [{}], weekly: [{}] },
      adVisit: { daily: [{}], hourly: [{}], monthly: [{}], weekly: [{}] },
      newAdUsers: { daily: [{}], hourly: [{}], monthly: [{}], weekly: [{}] },
    },
    initialSortStatus: { sortKey: 'visitsPerAd', sortType: 'desc' },
    fileName: 'web_data_table'
  };

  generateHeaders() {
    const { valueForTimeSelect, campaignAvgAdCost, valueForTypeSelect } = this.props;

    const typeSelected = valueForTypeSelect && valueForTypeSelect.type;

    const headers = partiableWebTableHeaders[typeSelected] 
      ? [
        { title: valueForTimeSelect.tableTitle, key: 'sortTimeKey' },
        ...partiableWebTableHeaders[typeSelected],
      ]
      : [
        { title: valueForTimeSelect.tableTitle, key: 'sortTimeKey' },
        ...partiableWebTableHeaders['default'],
      ];
    campaignAvgAdCost != null && headers.push({ title: 'Avg. Ad Cost', key: 'avgAdCost' });
    return { headers, campaignAvgAdCost };
  };

  generateTableData() {
    const {
      dataWebAnalytics,
      timeRange,
      inpdf,
      page,
      campaignAvgAdCost,
      rowsPerPage,
      isWebChartVisible,
      isCustomReport,
      initialSortStatus,
      rowsFirstPage
    } = this.props;
    const data = get(dataWebAnalytics, ['visit', timeRange], []);
    
    const dataSet = data && data.reduce((accum, entry, index) => {
      const { time, firstValue } = entry;

      // const user = get(dataWebAnalytics, ['user', timeRange, `${index}`, 'firstValue']);
      const adVisit = get(dataWebAnalytics, ['adVisit', timeRange, `${index}`, 'firstValue']);
      const newAdUsers = get(dataWebAnalytics, [newAdUsersKey, timeRange, `${index}`, 'firstValue']);
      // const adUser = get(dataWebAnalytics, ['adUser', timeRange, `${index}`, 'firstValue']);
      const ads = get(dataWebAnalytics, ['ads', timeRange, `${index}`, 'firstValue']);
      const visitsPerAd = (
        ads === 0 ? 0 :
          parseFloat((adVisit / ads).toFixed(2))
      );
      const newAdUsersPerAds = (
        ads === 0 ? 0 :
          parseFloat((newAdUsers / ads).toFixed(2))
      );
      const avgAdCost = get(dataWebAnalytics, ['avgAdCost', timeRange, `${index}`, 'firstValue']);

      if (data) {
        accum.tableRowData.push({
          time,
          visit: firstValue,
          // user,
          adVisit,
          // adUser,
          ads,
          visitsPerAd,
          avgAdCost,
          newAdUsers,
          newAdUsersPerAds,
          sortTimeKey: index
        });
        accum.summaryData.totalVisits += firstValue || 0;
        // accum.summaryData.totalUsers += user || 0;
        accum.summaryData.totalAdVisits += adVisit || 0;
        // accum.summaryData.totalAdUsers += adUser || 0;
        accum.summaryData.totalAds += ads || 0;
        accum.summaryData.totalNewAdUsers += newAdUsers || 0;
      }
      return accum;
      // }, { tableRowData: [], summaryData: {title: 'Grand Total', totalVisits: 0, totalUsers: 0, totalAdVisits: 0, totalAdUsers: 0, totalAds: 0, totalVisitsPerAd: 0, avgAdCost: 0 }});
    }, { tableRowData: [], summaryData: { title: 'Grand Total', totalVisits: 0, totalAdVisits: 0, totalAds: 0, totalVisitsPerAd: 0, campaignAvgAdCost: 0, totalNewAdUsers: 0, totalVisitsPerAds: 0 } });
    dataSet.summaryData.totalVisitsPerAd = parseFloat((dataSet.summaryData.totalAdVisits / dataSet.summaryData.totalAds).toFixed(2)) || 0;
    dataSet.summaryData.totalNewAdUsersPerAds = parseFloat((dataSet.summaryData.totalNewAdUsers / dataSet.summaryData.totalAds).toFixed(2)) || 0;

    dataSet.summaryData.campaignAvgAdCost = campaignAvgAdCost;
    //TODO: we will want to update the API to include sumAvgAdCost so we can calculate the campaignAvgAdCost in summaryData instead of copying from chartData

    if ( inpdf ) {
      const { sortKey, sortType } = initialSortStatus || {};
      dataSet.tableRowData = orderBy(dataSet.tableRowData, [sortKey], sortType);
      const rowsOnFirstPage = rowsFirstPage || MIN_LENGTH_CUSTOM_WEB_ANALYTICS_TABLE_ROWS;
      const minRows = isCustomReport ? rowsOnFirstPage : MIN_LENGTH_WEB_ANALYTICS_DATA;
      const { tableRowsFirstPage, tableRowsOtherPage } = calculateTableRows({ displayChart: isWebChartVisible, isCustomReport, minRows, truncatedRows: 0 });
      if ( page === 0) {
        dataSet.tableRowData = dataSet.tableRowData.slice(0, rowsPerPage);
      } else {
        const startIndex = (tableRowsFirstPage + 1) + (page - 1) * (tableRowsOtherPage + 1);
        dataSet.tableRowData = dataSet.tableRowData.slice(startIndex, startIndex + rowsPerPage );
      }
    }
    return dataSet;
  };

  prepCsvData(data, range, initialSortStatus) {
    const { campaignAvgAdCost, valueForTypeSelect } = this.props;

    const isNewAdUserSelected = valueForTypeSelect && valueForTypeSelect.type === newAdUsersKey;

    const sortKey = initialSortStatus.sortKey === 'visitsPerAd' ? 'visitsPerAd' : 'time';
    const sortData = orderBy(data, [sortKey], 'desc');
    // const csvHeaders = [`Time Range ${range}`, 'Total Visits', 'Total Users', 'Ad Visits', 'Ad Users', 'Ads', 'AdVists/Ads'];
    const csvHeaders = isNewAdUserSelected 
      ? [`Time Range ${range}`, 'Total Visits', 'New Ad Users', 'Ads', 'New Ad Users/Ads']
      : [`Time Range ${range}`, 'Total Visits', 'Ad Visits', 'Ads', 'AdVists/Ads'];
    campaignAvgAdCost != null && csvHeaders.push('Avg. Ad Cost');
    return sortData && sortData.reduce((accum, entry) => {
      // const { time, visit, user, adVisit, adUser, ads, visitsPerAd, avgAdCost } = entry;
      // const csvData = [ time, visit, user, adVisit, adUser, ads, visitsPerAd ];
      const { time, visit, adVisit, ads, visitsPerAd, avgAdCost, newAdUsers, newAdUsersPerAds } = entry;
      const formattedAvgAdCost = typeof avgAdCost === 'number' ? avgAdCost.toFixed(2) : 'N/A';
      const csvData = isNewAdUserSelected 
        ? [ time, visit, newAdUsers, ads, newAdUsersPerAds ]
        : [ time, visit, adVisit, ads, visitsPerAd ];
      campaignAvgAdCost != null && csvData.push(formattedAvgAdCost);
      accum.push(csvData);
      return accum;
    }, [csvHeaders]);
  };

  handleCellClick = ({ data }) => {
    const { onCellClick } = this.props;
    onCellClick && onCellClick(data);
  };

  exportContainer = React.createRef();

  render() {
    const {
      initialSortStatus,
      range,
      fileName,
      inpdf,
      page,
      isChartVisible,
      rowsPerPage,
      isGrandTotalDisplay,
      isCustomReport,
      tableIndex,
      valueForTypeSelect,
    } = this.props;
    const dataSet = this.generateTableData();
    const { headers, campaignAvgAdCost } = this.generateHeaders();
    const csvData = this.prepCsvData(dataSet.tableRowData, range, initialSortStatus);
    const isNewAdUserSelected= valueForTypeSelect && valueForTypeSelect.type === newAdUsersKey;

    return (
      <div data-test="webTable" className={styles.tableContainer}>
        {
          isChartVisible ? (
            <ModuleExport
              exportImg={this.exportContainer}
              data={csvData}
              fileName={fileName}
            />
          ) : ''
        }

        <div className={styles.exportContainer} ref={this.exportContainer}>
          <BaseDataTable
            inpdf={inpdf}
            data={dataSet.tableRowData}
            tableHead={<WebTableHeader headers={headers} />}
            tableRow={
              <WebTableRow
                campaignAvgAdCost={campaignAvgAdCost}
                isCustomReport={isCustomReport}
                isNewAdUserSelected={isNewAdUserSelected}
              />
            }
            tableSummary={
              <WebTableSummary 
                summaryData={dataSet.summaryData} 
                campaignAvgAdCost={campaignAvgAdCost} 
                isNewAdUserSelected={isNewAdUserSelected}
              />
            }
            pagination
            initialSortStatus={initialSortStatus}
            onBodyCellClick={this.handleCellClick}
            page={page}
            rowsPerPage={rowsPerPage}
            isGrandTotalDisplay={isGrandTotalDisplay}
            tableId={GA_CHART_ID}
            tableIndex={tableIndex}
            isCustomReport={isCustomReport}
            isNewAdUserSelected={isNewAdUserSelected}
          />
        </div>
      </div>
    )
  };
};